




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { JobServiceFormRequest } from '@/models/jobServiceForm/jobServiceFormRequest';
import { RiskMatrixItemRequest } from '@/models/jobServiceForm/riskMatrixItemRequest';
import * as JobsAPI from '@/api/jobsApi';
import ServiceDetailsForm from '@/components/jobServiceForm/ServiceDetailsForm.vue';
import PersonalProtectiveEquipmentForm from '@/components/jobServiceForm/PersonalProtectiveEquipmentForm.vue';
import RiskMatrixForm from '@/components/jobServiceForm/RiskMatrixForm.vue';
import JobCompleteSignOffForm from '@/components/jobServiceForm/JobCompleteSignOffForm.vue';
import SwmsScopeStatement from '@/components/jobServiceForm/SwmsScopeStatement.vue';
import RiskMatrixReference from '@/components/jobServiceForm/RiskMatrixReference.vue';
import ServiceFormApprovalStatement from '@/components/jobServiceForm/ServiceFormApprovalStatement.vue';
import Nullable from '@/types/nullable';
import { vxm } from '@/stores';
import { JobUserStatusEnum } from '@/types/jobUserStatus';
import { RiskMatrixOptions } from '../../models/jobServiceForm/riskMatrixOptions';

@Component({
  components: {
    ServiceDetailsForm,
    PersonalProtectiveEquipmentForm,
    RiskMatrixForm,
    JobCompleteSignOffForm,
    SwmsScopeStatement,
    RiskMatrixReference,
    ServiceFormApprovalStatement
  }
})
export default class JobServiceFormEdit extends Vue {
  @Prop({ type: String, default: null }) public jobID!: string;
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;
  @Prop({ type: Object, default: null }) public loadedForm!: Nullable<JobServiceForm>;
  @Prop({ type: Object, default: null }) public riskMatrixOptions!: Nullable<RiskMatrixOptions>;

  private data: JobServiceFormRequest = this.loadFromModel();
  private loading: boolean = false;
  private errorMessage: string = null;

  loadFromModel(): JobServiceFormRequest {
    let serviceNotes = null;
    if(this.loadedForm != null){
      serviceNotes = this.loadedForm.serviceNotes;
    }

    let siteSignIn = null;
    if(this.loadedForm != null && this.loadedForm.siteSignIn != null){
      siteSignIn = this.loadedForm.siteSignIn.id;
    }

    let siteInduction = null;
    if(this.loadedForm != null && this.loadedForm.siteInduction != null){
      siteInduction = this.loadedForm.siteInduction.id;
    }

    let swmsJsaComplete = null;
    if(this.loadedForm != null && this.loadedForm.swmsJsaComplete != null){
      swmsJsaComplete = this.loadedForm.swmsJsaComplete.id;
    }

    let fridgeSignOffSheetsComplete = null;
    if(this.loadedForm != null && this.loadedForm.fridgeSignOffSheetsComplete != null){
      fridgeSignOffSheetsComplete = this.loadedForm.fridgeSignOffSheetsComplete.id;
    }

    let interimFailedItemsReport = null;
    if(this.loadedForm != null && this.loadedForm.interimFailedItemsReport != null){
      interimFailedItemsReport = this.loadedForm.interimFailedItemsReport.id;
    }

    let ppe: number[] = [];
    if(this.loadedForm != null && this.loadedForm.ppe != null){
      ppe = this.loadedForm.ppe.map((x): number => x.id);
    }

    let loadDefaults = true;
    let riskMatrix: RiskMatrixItemRequest[] = [];    
    if(this.loadedForm != null) {
      if(this.loadedForm.riskMatrix != null){
        riskMatrix = this.loadedForm.riskMatrix.map((x): RiskMatrixItemRequest => {          
          let workActivity = null;
          if(x.workActivity != null){
            workActivity = x.workActivity.id;
          }

          let riskScore = null;
          if(x.riskScore != null){
            riskScore = x.riskScore.id;
          }

          let residualRiskScore = null;
          if(x.residualRiskScore != null){
            residualRiskScore = x.residualRiskScore.id;
          }

          let workActivityOption = this.riskMatrixOptions.workActivityOptions.find((y): boolean => y.id == x.workActivity.id);

          return {
            workActivity,
            risks: x.risks,
            riskScore,
            controlMeasures: x.controlMeasures,
            residualRiskScore,
            riskRisks: x.riskRisks,
            riskControlMeasures: x.riskControlMeasures,
            workActivityFreeText: x.workActivityFreeText,
            jobDefault: workActivityOption.jobDefault
          };
        });
      }

      // If we have a signature, we can't change the risk matrix options
      if(this.loadedForm.riskMatrixSignOffs != null && this.loadedForm.riskMatrixSignOffs.length > 0){        
        loadDefaults = false;        
      }
    }
    
    if (loadDefaults){
      // Fetch work activities defined by the jobDefault flag on workActivity      
      let defaults = this.riskMatrixOptions.workActivityOptions
        .filter((w): boolean => w.jobDefault == true)
        .map((y): RiskMatrixItemRequest => {
          return {
            workActivity: y.id,
            risks: null,
            riskScore: y.riskScoreId,
            controlMeasures: null,
            residualRiskScore: y.residualRiskScoreId,
            riskRisks: this.riskMatrixOptions.riskOptions.filter(o => o.workActivityId == y.id),
            riskControlMeasures: this.riskMatrixOptions.controlMeasureOptions.filter(o => o.workActivityId == y.id),
            workActivityFreeText: null,
            jobDefault: y.jobDefault
          }
        });

      // Only add defaults if they do no exist in risk matrix
      riskMatrix = riskMatrix.concat(defaults.filter(d => !riskMatrix.some(r => r.workActivity == d.workActivity)));
    }

    return {
      jobID: this.jobID,
      serviceNotes,
      siteSignIn,
      siteInduction,
      swmsJsaComplete,
      fridgeSignOffSheetsComplete,
      interimFailedItemsReport,
      ppe,
      riskMatrix,
      riskMatrixSignOff: null,
      technicianJobCompleteSignOff: null,
      clientJobCompleteSignOff: null
    };
  }

  get loggedInUser(){
    return vxm.user.id
  }

  goBack(){
    if(!this.valid()){
      return;
    }

    this.$router.go(-1);
  }

  async save(){
    // Validate before saving
    if(!this.valid()){
      return;
    }
    
    this.loading = true;

    try {
      await JobsAPI.createOrUpdateServiceForm(this.data);

      this.$emit('onDataChanged');
    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;
  }

  valid() {
    let errors = [];
    this.errorMessage = null;

    if(!this.atLeastOneNonDefaultRiskItem() && this.job.assignment.latestStatus.status.id === JobUserStatusEnum.START_CONTINUE_WORK){
      errors.push("Hazard/Risk Controls - At least one more risk item needs to be captured!");
    }

    if(!this.riskMatrixSigned() && this.job.assignment.latestStatus.status.id === JobUserStatusEnum.START_CONTINUE_WORK){
      errors.push("Hazard/Risk Controls - Needs to be signed!");
    }

    if(!this.clientSignOff() && this.job.assignment.latestStatus.status.id === JobUserStatusEnum.FINISH_WORK){
      errors.push("Client needs to sign off job complete!");
    }

    if (errors.length > 0){
      this.errorMessage = errors.join('\n');
      return false;
    }

    return true;
  }

  atLeastOneNonDefaultRiskItem(){
    return this.data.riskMatrix.some(a => !a.jobDefault);
  }

  riskMatrixSigned(){
    if(this.data.riskMatrixSignOff != null){
      return true;
    }

    if(this.loadedForm != null && this.loadedForm.riskMatrixSignOffs != null){
      let riskMatrixSignOff = this.loadedForm.riskMatrixSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(riskMatrixSignOff != null){
        return true;
      }
    }

    return false;
  }

  clientSignOff(){
    if(this.data.clientJobCompleteSignOff != null){
      return true;
    }

    if(this.loadedForm != null && this.loadedForm.clientJobCompleteSignOff != null){
      return true;
    }

    return false;
  }
}

